import { DateRange, TimestampDateRange } from 'shared/types/models';

export function convertToTimestampRangeDate({ end, start }: DateRange): TimestampDateRange {
  return {
    start: new Date(start).getTime(),
    end: new Date(end).getTime(),
  };
}
